<template>
    <div v-if="loading" class="loading-page" v-cloak>
                <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
                <img src="../../assets/loading.gif" alt="" class="mt-3">
            <img src="../../assets/logo.svg" alt="" class="logo mt-3">
    </div>
 <div v-else class="obras">
        <div class="container">
            <h2 class="text-center">Proyectos Arquitectura Corporativa</h2>
        </div>
        <div class="container">
            <div class="cuadro-obras">
                <div  v-for="(obra, i) in paginatedData()" :key="i">
                    <router-link v-if="(obra.slide1 && obra.slide2 && obra.slide3 && obra.descripcion && obra.titulo) !== null"  :to="`/proyecto/${obra.id}/${obra_seccion}`"  class="link-r " tag="div" >
                        <progressive-background class="obra-img"  :src="`https://espais.com.py${obra.imagen_presentacion.data.thumbnail_url}`">
                            <div slot="content" slot-scope="{ visible }">
                                  <div class="caja-o" v-if="obra.titulo">
                                    <div class="overlay-comercio">
                                        <div class="texto-comercio">
                                          {{obra.titulo}}
                                       </div>
                                    </div>
                                </div>
                            </div>
                        </progressive-background>
                    </router-link>
                    <div v-else class="link-r">
                          <progressive-background class="obra-img-nolink"  :src="`https://espais.com.py${obra.imagen_presentacion.data.thumbnail_url}`">
                            <div slot="content" slot-scope="{ visible }">
                                  <div class="caja-o" v-if="obra.titulo">
                                    <div class="overlay-comercio">
                                        <div class="texto-comercio">
                                          {{obra.titulo}}
                                       </div>
                                    </div>
                                </div>
                            </div>
                          </progressive-background>
                    </div>
                </div>
             </div>
              <div class="paginador mt-3" v-if="pageCount()>1">
                  <div class="flechas-paginador">
                           <button @click="prevPage" :disabled="pageNumber==0" class="boton-productos">
                                <i class="fas fa-chevron-left"></i>
                            </button>
                            <button @click="nextPage" :disabled="pageNumber >= pageCount()-1" class="boton-productos">
                               <i class="fas fa-chevron-right"></i>
                            </button>
                  </div>
              
            </div>
        </div>
    </div>
   
</template>
<script>
export default {
    data(){
        return{
            loading: false,
            home:[],
            obra_seccion:'',
            pageNumber:0,
            size:8
        }
    },
    methods:{
        nextPage(){
         this.pageNumber++;
      },
      prevPage(){
        this.pageNumber--;
      },
      pageCount(){
      let l = this.home.length,
          s = this.size;
      return Math.ceil(l/s);
      },
      paginatedData(){
      const start = this.pageNumber * this.size,
            end = start + this.size;
    
      return this.home.slice(start, end);
      },


    loadLogs () {
       this.$http.get(`https://espais.com.py/admin/api/1.1/tables/proyectos_corporativos/rows`,{before:() => {this.loading = true;}})
        .then(function (data) {
           this.home = data.body.data;
           this.obra_seccion = data.body.meta.table;
        }).then(() => {this.loading = false;})
      }
    },
    mounted () {
    this.$nextTick(function () {
      this.loadLogs();
    })
    }

}
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/components/proyectos/Proyectos_corporativos.vue